<template>
<div>
<h2 class="h2-responsive font-weight-bold text-center my-5">Tipps zum Kauf</h2>
<div class="card card-image" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fa%20(31).JPG?alt=media&token=48b67c08-3cdf-4254-902f-dab8c3285e51')">
  <div class="rgba-black-strong py-5 px-4">
    <mdb-container>
      <row center>
        <column md="10" xl="8">
          <accordion :panes="panes" photoBg></accordion>
        </column>
      </row>
  </mdb-container>
  </div>
</div>
</div>
</template>

<script>
  import { mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbTextarea, Accordion } from 'mdbvue';
  export default {
    components: {
      Accordion,
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbTextarea,
      mdbCard,
      mdbCardBody
    },
    data() {
      return {
        panes: [
          {
            title: 'Wie lange dauert der Transport nach Deutschland?',
            icon: 'cogs',
            content: `Durch die Abhängigkeit vieler Faktoren wie z.B. Logistik, Transportdistanz, Verkehrs- und Wetterverhältnisse, Transportfreigabe, Zahlungsverlauf und Informationsaustausch kann die komplette Abwicklung von der Auftragserteilung bis Abholung in Deutschland zwischen 6-8 Wochen liegen.`
          }, {
            title: 'Warum berechnen Sie den Überlandtransport nach Zonen und nicht nach der Distanz zum Zielort Miami?',
            icon: 'cogs',
            content: `Damit der Kunde sich nicht für jeden Standort eines Fahrzeuges ein neues Angebot einholen muss, haben wir den Überlandtransport in Zonen unterteilt, in denen die US-Staaten komplett integriert sind. So lassen sich die Transportkosten vor dem Kauf eines Fahrzeuges genau bestimmen.`
          },
          {
            title: 'Wie setzen sich die Transportzonen zusammen?',
            icon: 'cogs',
            content: `Aus Fahrstrecke, Anbindungen an Interstate-Highways und Ballungsrouten.`
          },
                    {
            title: 'Warum ist der Transportpreis abhängig von den Überlandtransportzonen?',
            icon: 'cogs',
            content: `Weil die Kosten für einen Überlandtransport von vielen Faktoren abhängig sind und daher oft variabel berechnet werden. Die Kosten für eine Verschiffung hingegen können genauer kalkuliert werden.`
          },
                    {
            title: 'Bekomme ich einen Rabatt auf den Grundpreis, wenn ich mein Fahrzeug direkt bei Ihnen anliefere?',
            icon: 'cogs',
            content: `Ja, wir gewähren einen Rabatt bei Direktanlieferung. Diesen erfragen Sie bitte kurzfristig..`
          },
                    {
            title: 'Wie transportieren Sie mein Fahrzeug?',
            icon: 'cogs',
            content: `Wir transportieren Ihr Fahrzeug für den Überlandtransport mit offenen Fahrzeugaufliegern mit eine Ladekapazität von bis zu 10 Fahrzeugen. Auf Wunsch bieten wir auch Überlandtransporte in geschlossenen Containern an. Der Überseetransport erfolgt in geschlossen Frachtcontainern. Überschreitet ein Fahrzeug die angegebenen Frachtmaße für einen Containertransport, wird Roll-on/Roll-off verschifft.`
          },
                    {
            title: 'Wann wird mein Fahrzeug gefahren?',
            icon: 'cogs',
            content: `Ihr Fahrzeug wird nur für den Vorgang des Be- und Entladens gefahren.`
          },
                    {
            title: 'Warum ist des Verladen von nicht fahrtauglichen Fahrzeugen teurer?',
            icon: 'cogs',
            content: `Weil das Verladen dieser Fahrzeuge mit einem höheren Aufwand verbunden ist. Das Fahrzeug muss z.B. mit einer Winde auf den Überlandtransporter gezogen werden und im Verlauf des gesamten Transportes „von Hand“ rangiert werden.`
          },
                    {
            title: 'Kann ich den Kofferraum des Fahrzeuges beladen?',
            icon: 'cogs',
            content: `Ja, sollten Sie noch Ersatzteile oder Ähnliches in den USA kaufen wollen, ist der Transport innerhalb des Fahrzeuges möglich. Nach vorheriger Absprache sind wir Ihnen gerne behilflich! `
          },
                    {
            title: 'Warum muss ich eine Anzahlung leisten?',
            icon: 'cogs',
            content: `Bis zu dem Zeitpunkt der Anzahlung ist unser Angebot unverbindlich. Erst mit einer Anzahlung wird Ihr Transportauftrag bestätigt und disponiert.`
          },
                    {
            title: 'Wann leiste ich die Restzahlung?',
            icon: 'cogs',
            content: `Sobald ein Termin für eine Verladung nach Übersee ansteht, werden Sie von uns gebeten, die Restzahlung zu begleichen. Erst nach Erhalt des vollen Rechnungsbetrages wird Ihr Fahrzeug für den Überseetransport freigegeben.`
          },
                    {
            title: 'Ich kann die Größe meines Fahrzeuges nicht genau bestimmen.',
            icon: 'cogs',
            content: `Ihre Angabe zur Größe des Fahrzeuges ist unverbindlich. Die genaue Größe kann erst beim Verladen bestimmt werden. Es kann sein, dass Ihr Fahrzeug dann in eine kleinere oder größere Kategorie eingestuft wird.`
          },
                    {
            title: 'Kann ich mein Fahrzeug in den USA selber fahren, bevor es verschifft wird?',
            icon: 'cogs',
            content: `Ja, gerne sind wir Ihnen bei der Suche nach Ihrem Traumfahrzeug behilflich. Ihre unverbindlichen Anfragen werden wir gerne beantworten!`
          },
                              {
            title: 'Ist mein Fahrzeug während des kompletten Transportes versichert?',
            icon: 'cogs',
            content: `Ja, sowohl beim Überlandtransport als auch während des Überseetransportes ist Ihr Fahrzeug versichert. Genauere Informationen entnehmen Sie bitte den aufgeführten Vertragsbedingungen.`
          },
                              {
            title: 'Wie kann ich den Status meines Auftrags prüfen?',
            icon: 'cogs',
            content: `Sie bekommen laufend eine Statusmitteilung per E-Mail zugeschickt. Sie können uns auch jederzeit von sich aus kontaktieren.`
          },
                              {
            title: 'Bieten Sie auch Unterstützung bei der Suche nach einem Fahrzeug an?',
            icon: 'cogs',
            content: `Ja, sowohl beim Überlandtransport als auch während des Überseetransportes ist Ihr Fahrzeug versichert. Genauere Informationen entnehmen Sie bitte den aufgeführten Vertragsbedingungen.`
          },
        ]
      }
    }
  }
</script>

<style scss>
.md-accordion .card .card-body,
.md-accordion .card  {
  color: #efefef;
  background-color: #141414;
}
#accordiontitle {
  padding-top: 20px;
  padding-bottom: 40px;
}
#accordiontitle span {
  color: blue !important;
}
.card-header {
  background-color: rgb(25, 118, 210) !important;
}
</style>